export default "__VITE_ASSET__db5bfbcc__"